import React, { useEffect, useContext, useState } from "react";
import { Box, Button, Container } from "@mui/material";
import { makeStyles } from "@mui/styles";
import HomeLayout from "layouts/HomeLayout";
import { useTranslation } from "react-i18next";
import { useRouter } from "next/router";
import { getNewsList } from "context/actions/news";
import BestList from "components/BestList";
import ButtonList from "components/ButtonList";
import Cover from "components/Cover";
import Help from "components/Help";
import Location from "components/Location";
import Calculator from "components/Calculator";
import i18n from "i18next";
import { Height } from "@mui/icons-material";
import { getLocationList } from "context/actions/location";
import { getConnectList } from "context/actions/connect";
import { getLinkList } from "context/actions/link";
import { getInstList } from "context/actions/inst";
import { getPriceList } from "context/actions/price";
import { getTimeList } from "context/actions/time";
import { getTrainingList } from "context/actions/training";
import { getInfoList } from "context/actions/info";
import useWindowSize from "utils/useWindowSize";
import { getCoverList } from 'context/actions/cover';
import Slider from 'components/Slider';
import Image from "next/image";

const useStyles = makeStyles((theme) => ({}));

const HomePage = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const router = useRouter();
  const { sizes } = useWindowSize();
  const [location, setLocation] = useState([]);
  const [link, setLink] = useState([]);
  const [info, setInfo] = useState([]);
  const [price, setPrice] = useState([]);
  const [time, setTime] = useState([]);
  const [training, setTraining] = useState([]);
  const [connect, setConnect] = useState([]);
  const [covers, setCovers] = useState([]);

  useEffect(() => {
    getInitData();
  }, []);

  const getInitData = async () => {
    const resCover = await getLocationList();
    if (resCover.status === "success") setLocation(resCover.data);

    const resLink = await getLinkList();
    if (resLink.status === "success") setLink(resLink.data);

    const resInfo = await getInfoList();
    if (resInfo.status === "success") setInfo(resInfo.data.list);

    const resPrice = await getPriceList();
    if (resPrice.status === "success") setPrice(resPrice.data);

    const resTime = await getTimeList();
    if (resTime.status === "success") setTime(resTime.data);
   
    const resTraining = await getTrainingList();
    if (resTraining.status === "success") setTraining(resTraining.data);
    
    const resConnect = await getConnectList();
    if (resConnect.status === "success") setConnect(resConnect.data);

    const resCovers = await getCoverList();
    if (resCovers.status === 'success') setCovers(resCovers.data);
  };
  

  return (
    <Container maxWidth={false} disableGutters={true} className="">
      {/* <Box className="max-h-[500px] w-full"> */}
      <Slider linkData={covers} />
      <BestList linkData={link} />
      <ButtonList  location={location}  connect={connect}   price={price} time={time} training={training}/>
      <Box
        sx={{
          backgroundImage: "url(22.png)",
          height: 300,
          backgroundSize: "cover",
          paddingTop: 10,
          display: "flex",
          alignItems: "center",
          justifyContent: "end",
          paddingBottom: 10,
          backgroundAttachment: "fixed",
          backgroundPosition: "center",
          position: "relative",
          marginTop: 5,
          "&::before": {
            content: '""',
            position: "absolute",
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            background: "rgb(13 14 46 / 80%)",
            zIndex: 1,
          },
        }}
      >
        <Box className="w-full text-center flex justify-center px-4">
          <Box className="max-w-[800px] w-full z-[2] italic text-white font-semibold text-xl md:text-2xl lg:text-3xl">
            "Mandal Карго түргэн шуурхай, найдвартай үйлчилгээ үзүүлдэгт
            баярлалаа"
          </Box>
        </Box>
      </Box>
      {/* <Calculator /> */}
      <Help location={info} linkData={link} />
      {/* <Location location={location} linkData={link} /> */}
    </Container>
  );
};

HomePage.Layout = HomeLayout;

export default HomePage;
